import type { AsyncActionAPI } from 'src/replicant/config/actions/createSharedStatesActions';
import {
  canParticipateOnTeamCompetition,
  getTeamEventAnalytics,
} from '../competition/teamCompetition.getters';
import { getCurrentTeamEventId } from '../team.getters';

/**
 * Join team chest event.
 * @param teamId
 * @param rawApi
 * @returns Analytics data.
 */
export async function joinTeamChestEvent(
  teamId: string,
  api: AsyncActionAPI,
): Promise<
  | false
  | {
      teamId: string;
      tournamentUniqueId: string;
      opponentCount: number;
      memberCount: number;
      avgOpponentSize: number;
    }
> {
  // Fetch team state.
  const teamState = await api.sharedStates.team.fetch(teamId);
  if (!teamState) {
    throw new Error('Cannot join team event, team state is undefined.');
  }

  // Check if team can participate on team competition.
  if (!canParticipateOnTeamCompetition(teamState)) {
    throw new Error('Team cannot participate on team competition.');
  }

  // No event to join.
  const now = api.date.now();
  const eventId = getCurrentTeamEventId(now);
  if (!eventId) return false;

  // Already joined the event.
  if (teamState.global.events[eventId]) return false;

  // Notify the team in chat.
  api.sharedStates.team.postMessage.sendChatMessageToTeam(teamId, {
    timestamp: now,
    contents: {
      type: 'chestEvent',
    },
  });

  // Create competition.
  const competitionId = api.sharedStates.teamCompetition.create();
  api.sharedStates.teamCompetition.postMessage.setTeams(competitionId, {
    timestamp: now,
    teamIds: [teamId],
  });

  // Update team state.
  api.sharedStates.team.postMessage.createEvent(teamId, {
    timestamp: now,
    eventId,
    sharedStateId: competitionId,
    eventType: 'chest',
  });

  return getTeamEventAnalytics(teamId, competitionId, teamState, [], api);
}
